import React from 'react';
import Sentiment from '@op/components/Snippets/Sentiment';
import PercentageItem from '@op/components/Snippets/PercentageItem';
import type { IEventHeaderProps } from './types';
import './index.scss';
import useLanguage from '@op/hooks/useLanguage';

const sentimentMap: any = { up: 5, down: 1 };
const trendMap: any = { up: 1, down: -1 };
export default function EventHeader({
  title,
  trend,
  contribution,
  time,
}: Omit<IEventHeaderProps, 'onClose'>) {
  const { isEn } = useLanguage();
  // 根据 trend 计算 sentiment 值：up=1, down=-1, 其他=0
  const sentiment = sentimentMap[trend];
  const hint = isEn ? 'Note: The data scope for anomaly attribution is UTC+9, and represents a data snapshot taken at the time of attribution.' : '注：异动归因数据口径为UTC+9，且为归因时的切片数据';

  return (
    <div className="dbo-event-detail-header">
      <div className="dbo-event-detail-header__content">
        <div className="dbo-event-detail-header__left">
          {title && <div className="dbo-event-detail-header__title">{title}</div>}
          <div className="dbo-event-detail-header__info">
            <div className="dbo-event-detail-header__sentiment">
              <Sentiment sentiment={sentiment} showValue={false} />
            </div>
            <PercentageItem
              percentage={contribution * trendMap[trend]}
              showIcon={true}
            // formateFunc={(v) => `${v}%`}
            />
            <span className="dbo-event-detail-header__separator">|</span>
            <span className="dbo-event-detail-header__time">{time}</span>
          </div>
          <span className="dbo-event-detail-header__hint">{hint}</span>
        </div>
      </div>
    </div>
  );
}
